import Vue from "vue";

//External components
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import VueDraggable from 'vuedraggable';
import SlideUpDown from 'vue-slide-up-down'

//Internal components
import Tile from "./components/Tile";
import DialogTile from "./components/DialogTile";
import Notification from "./components/Notification";
import Fab from "./components/Fab";
import Icon from "./components/Icon";
import Progress from "./components/Progress";
import SettingComponent from "./components/SettingComponent";
import RuleComponent from "./components/RuleComponent";
import TileSelection from "./components/TileSelection";
import LoadingScreen from "./components/LoadingScreen";

export function registerComponents () {
    //External components
    Vue.component('v-select', vSelect);
    Vue.component("v-draggable", VueDraggable);
    Vue.component("v-slide-up-down", SlideUpDown);

    //Internal components
    Vue.component("Tile", Tile);
    Vue.component("DialogTile", DialogTile);
    Vue.component("Notification", Notification);
    Vue.component("Fab", Fab);
    Vue.component("Icon", Icon);
    Vue.component("SettingComponent", SettingComponent);
    Vue.component("RuleComponent", RuleComponent);
    Vue.component("TileSelection", TileSelection);
    Vue.component("LoadingScreen", LoadingScreen);
    Vue.component("Progress", Progress);
}

